var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAssesmentIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#404040;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M8.43,14.93H14.6a1,1,0,1,1,0,2H8.43a1,1,0,0,1,0-2Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M8.43,18.63H14.6a1,1,0,1,1,0,2H8.43a1,1,0,0,1,0-2Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M8.43,22.33H14.6a1,1,0,1,1,0,2H8.43a1,1,0,0,1,0-2Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M8.43,26H14.6a1,1,0,1,1,0,2H8.43a1,1,0,0,1,0-2Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M6.5,6.92h16A3.64,3.64,0,0,1,25.37,8.1,3.3,3.3,0,0,1,26,11a1,1,0,0,1-1,.83h-.17a1,1,0,0,1-.65-.41,1.05,1.05,0,0,1-.17-.75,1.44,1.44,0,0,0-.19-1.23,1.7,1.7,0,0,0-1.29-.46H6.5a1.31,1.31,0,0,0-1.31,1.3V31.29A1.31,1.31,0,0,0,6.5,32.6H22.08a1,1,0,1,1,0,2H6.5a3.32,3.32,0,0,1-3.31-3.32V10.23A3.31,3.31,0,0,1,6.5,6.92Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M39.55,33.22l-2.36-2.36a1.66,1.66,0,0,0-1.3-.44l-1-1a.85.85,0,0,0-1.21,0l-.65.61a.83.83,0,0,0-.26.61.85.85,0,0,0,.24.62l1,1a1.61,1.61,0,0,0,.44,1.31l2.35,2.36a1.58,1.58,0,0,0,1.13.45,2.08,2.08,0,0,0,2-1.88A1.55,1.55,0,0,0,39.55,33.22Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M26.62,13.78a8.68,8.68,0,1,0,3.11,16.77,8.78,8.78,0,0,0,3.06-2,8.68,8.68,0,0,0-6.17-14.77Zm4.89,6.29-5,5.75a1.31,1.31,0,0,1-.88.32,1.35,1.35,0,0,1-.92-.36l-.05-.06-2.91-3.29a.94.94,0,1,1,1.41-1.23L25.6,24l4.5-5.15a.94.94,0,0,1,1.41,1.23Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssesmentIcon);
export default __webpack_public_path__ + "static/media/assesment_icon.c35f792b34b001de209e3cd4fade4e85.svg";
export { ForwardRef as ReactComponent };